var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock flex-center"},[_vm._v(" "+_vm._s(_vm.hours)+":"+_vm._s(_vm.minutes)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }